import React, { useState, useEffect } from 'react';
import { Input, Row, Col, FormGroup,   Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,} from 'reactstrap';
import CurrencyInput from './CurrencyInput';
import checkmark from '../assets/icons/checkmark.png'

const SelectInput = (props) => {
  const {
    label="",
    options = [],
    initialOption = 0,
    onChangeOption,
    justLabel=false,
    isCurrency=false,
    typeInput='text',
    onChangeInput,
    valueInput,
    valueOption,
    minInput,
    maxInput,
    onRealTime = false,
    classNameInput = '',
    widthInput='100%',
    widthDropdown='100%'
  } = props

  const [ option, setOption ] = useState(0); 
  const [ value, setValue ] = useState(''); 
  const [ isVisible, setIsVisible ] = useState(false); 
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);


  useEffect(() => {
    if (initialOption!==0){
      setOption(initialOption)
    }

  }, [])

  useEffect(() => {
    if (valueInput!==value){
      setValue(valueInput)
    }
  }, [valueInput])

  useEffect(() => {
    if (valueOption!==null && option?.index!==valueOption?.index){
      setOption(valueOption.index)
    }
  }, [valueOption])


  const validateMinMax = (v) => {
    let amount = v;
    if (minInput!==null && amount<minInput){ 
      amount = minInput;
    }
    if (maxInput!==null && amount>maxInput) {
      amount = maxInput;
    }
    setValue(amount);
    return amount
  }

  return (
  <>
  <p className={`body-copy mb-8 ${justLabel ? 'mtn-40' : ''}`}>
    {label}
  </p>
    <Row className='mb-40'>
      <Col xs='auto' className='extra-small-component'>
        <FormGroup>
          <Input
            placeholder={isCurrency ? "$0" : "0"}
            tag={isCurrency && CurrencyInput}
            onBlur={event => {
              let amount = parseFloat(event.target.value.replace('$','').replace(',','') || 0);
              if(!onChangeInput || typeof(onChangeInput) !== 'function') return;
              if (minInput!==undefined || maxInput!==undefined) {
                amount = validateMinMax(amount)
              }
              onChangeInput(amount);
            }}
            style={{textAlign:justLabel && 'right', width: widthInput}}
            className={classNameInput}
            type={typeInput}
            value={value}
            onChange={event => {
              setValue(event.target.value || '')
              if (!onRealTime) return;
              let amount = parseFloat(event.target.value.replace('$','').replace(',','') || 0);
              if(!onChangeInput || typeof(onChangeInput) !== 'function') return;
              if (minInput!==undefined || maxInput!==undefined) {
                amount = validateMinMax(amount)
              }
              onChangeInput(amount,true);
            }}
          />
        </FormGroup>
      </Col>
      <Col xs='auto' className="extra-small-component">
        <FormGroup>

      <Dropdown
        disabled={justLabel} className="dropdown-select" isOpen={dropdownOpen} toggle={toggle} style={{width: widthDropdown}} >
        <DropdownToggle
        className={justLabel ? 'notArrow' : ''}
        caret>{options[option]?.label}</DropdownToggle>

        <DropdownMenu>


        {options.map((item)=>(
    <DropdownItem
    className={`option ${option===item.value ? 'selected' : ''}`}
    style={{width: widthDropdown-2}}
    onClick={(e) => {
      e.preventDefault();
      setOption(item.value);
      if(!onChangeOption || typeof(onChangeOption) !== 'function') return;
      onChangeOption(options[item.value]);
      setIsVisible(false);
    }}
    >
      {(option===item.value) && <img className="mr-8" src={checkmark}/>}
      <p className={option===item.value ? '' : 'marginExtra'}
      >{item.label}</p>
    </DropdownItem>
  ))
  }

        </DropdownMenu>
      </Dropdown>

        </FormGroup>
      </Col>
    </Row>
  </>  
  )
}

export default SelectInput;

